// A nonce is generated at page load and automatically injected into the page. This nonce
// is accepted by the CSP. This function grabs that nonce from the html
export const extractCSPNonce = (
  srcType: 'script' | 'style',
): string | undefined => {
  return document
    .querySelector('meta[http-equiv="Content-Security-Policy"]')
    ?.getAttribute('content')
    ?.split(/;\s?/)
    ?.filter((it) => it.startsWith(`${srcType}-src`))
    ?.map((it) => it.match("'nonce-(.*)'")?.[1])?.[0];
};
